<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : outStockBills.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      class="outStockBillsEdit"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="outStockBills"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="领料单号" prop="billNo">
            <el-input v-model="outStockBills.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="领料仓" prop="locationName">
            <el-input
                v-model="outStockBills.locationName"
                :disabled="outStockBills.pkid > 0"
                readonly
                placeholder="请选择仓位">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="outStockBills.pkid > 0"
                  @click="$refs.locationSelect.open()"/>
            </el-input>
            <warehouse-location-select ref="locationSelect" @select="locationSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单据编号" prop="relBillNo">
            <el-input
                v-model="outStockBills.relBillNo"
                :disabled="outStockBills.pkid > 0"
                readonly
                placeholder="请选择关联单据编号">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :disabled="outStockBills.pkid > 0"
                  @click="$refs.productionOrderSelect.open()"/>
            </el-input>
            <production-order-select ref="productionOrderSelect" @select="productionOrderSelect"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工单物料类型" prop="materialTypeName">
            <el-input v-model="outStockBills.materialTypeName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="要求日期" prop="requireDate">
            <el-date-picker
                v-model="outStockBills.requireDate"
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="outStockBills.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单时间" prop="createTime">
            <el-input v-model="outStockBills.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="outStockBills.pkid > 0" :span="12">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="outStockBills.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="outStockBills.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle" style="margin-top: 10px">领料明细</div>
      <div style="text-align: right;margin-bottom: 10px;">
        <el-button v-if="!disabled" type="primary" @click="$refs.BatchFLlocationSelect.open()">批量更新仓位</el-button>
        <warehouse-location-select ref="BatchFLlocationSelect" @select="BatchFLlocationSelect"/>
      </div>
      <el-table
          class="tableBox"
          :data="outStockBillDetailVOS"
          border
          height="350"
          @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="140"/>
        <el-table-column prop="specification" align="left" label="规格型号" width="220"/>
        <el-table-column prop="materialName" align="left" label="物料名称" min-width="150"/>
        <el-table-column prop="RefRowIndex" align="center" label="发料仓" width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择发料仓">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.FLlocationSelect.open();setIndex(scope.$index)"/>
            </el-input>
            <warehouse-location-select ref="FLlocationSelect" @select="FLlocationSelect"/>
          </template>
        </el-table-column>
        <el-table-column prop="unitName" align="center" label="单位" width="60"/>
        <!-- <el-table-column prop="price" align="center" label="单价" width="60"/> -->
        <el-table-column align="center" label="领料数量" width="100" prop="quantity"/>
        <el-table-column
            prop="note"
            align="center"
            label="备注"
            width="120"
            show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.note" type="textarea"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import ProductionOrderSelect from "@/views/ProductionManagement/ProductionOrder/ProductionOrderSelect";
  import WarehouseLocationSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";

  export default {
    name: "OutStockOrderEdit",
    components: {ProductionOrderSelect, WarehouseLocationSelect},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        index: 0,
        outStockBills: {
          outStockType: 2,
          pkid: 0,
          billNo: "",
          relBillNo: "",
          relBillId: "",
          requireDate: "",
          status: "",
          statusName: "",
          creatorName: "",
          createTime: "",
          note: "",
          locationName: "",
          locationNo: "",
          locationId: "",
          outStockBillDetailVOS: [],
        },
        outStockBillDetailVOS: [],
        multipleSelection: [],
        ruleValidate: {
          locationName: {required: true, message: "请选择领料仓位", trigger: "change"},
          FLlocationName: {required: true, message: "请选择发料仓位", trigger: "change"},
          quantity: {required: true, trigger: "blur"},
          relBillNo: {required: true, message: "请选择关联单号", trigger: "change"},
          requireDate: {required: true, message: "请选择要求时间", trigger: "change"},
        },
      };
    },
    methods: {
      open(row, disabled) {
        this.dialogVisible = true;
        if (row) {
          this.outStockBills.pkid = row.pkid;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        // this.outStockBills.outStockBillDetailVOS = val;
      },

      // 根据出货订单id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `outStockProductions/${this.outStockBills.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.outStockBills = Object.assign(this.outStockBills, resp.data);
              // this.outStockBills.locationName = this.outStockBills.warehouseName + "-" + this.outStockBills.locationName;
              this.outStockBills.locationName = this.outStockBills.locationName + "(" + this.outStockBills.warehouseName + ")";
              this.outStockBills.outStockBillDetailVOS.forEach(item => {
                // item.locationName = item.warehouseAreaName + "-" + item.locationName;
                item.locationName = item.locationName + "(" + item.warehouseAreaName + ")";
              });
              this.outStockBillDetailVOS = this.outStockBills.outStockBillDetailVOS;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      setIndex(index) {
        this.index = index;
      },

      //仓位选择
      locationSelect(row) {
        this.outStockBills.locationName = row.warehouseLocationName + "(" + row.warehouseAreaName + ")";
        this.outStockBills.locationNo = row.warehouseLocationNo;
        this.outStockBills.locationId = row.pkId;
      },

      BatchFLlocationSelect(row) {
        this.outStockBillDetailVOS.forEach(item => {
          item.locationName = row.warehouseLocationName + "(" + row.warehouseAreaName + ")";
          item.locationId = row.pkId;
        });
      },

      FLlocationSelect(row) {
        this.outStockBillDetailVOS[this.index].locationName = row.warehouseLocationName + "(" + row.warehouseAreaName + ")";
        this.outStockBillDetailVOS[this.index].locationId = row.pkId;
      },

      //选择关联单号
      productionOrderSelect(row) {
        this.outStockBills.relBillNo = row.billNo;
        this.outStockBills.relBillId = row.pkid;
        this.outStockBills.locationId = row.locationId;
        this.outStockBills.locationName = row.warehouseLocationName + "(" + row.warehouseAreaName + ")";
        this.outStockBills.requireDate = row.planStartTime;
        this.outStockBills.materialTypeId=row.materialTypeId;
        this.outStockBills.materialTypeNo=row.materialTypeNo;
        this.outStockBills.materialTypeName=row.materialTypeName;
        this.getOrderDetail(row.pkid);
      },

      //根据单号获取明细
      getOrderDetail(id) {
        this.$http.get("basic", `outStockProductions/getDetailByTask/${id}`).then((res) => {
          this.outStockBillDetailVOS = res.data;
          this.outStockBillDetailVOS.forEach(item => {
            if (item.warehouseAreaName) {
              item.locationName = item.locationName + "(" + item.warehouseAreaName + ")";
            }
          });
        });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.multipleSelection.length) {
              this.$confirm("请勾选库存明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            let flag = false;
            this.multipleSelection.forEach(item => {
              if (!item.locationName) {
                flag = true;
              }
            });
            if (flag) {
              this.$confirm("请选择发料仓", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.outStockBills.outStockBillDetailVOS = this.multipleSelection;
            // console.log(this.outStockBills);
            this.submitLoading = true;
            this.$http
              .save("basic", "outStockProductions", this.outStockBills)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.outStockBills.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.outStockBillsEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.outStockBillsEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.outStockBillsEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 10px;
  padding-bottom: 69px;
  height: 90%;
}

.outStockBillsEdit .el-divider--horizontal {
  margin: 10px 0;
}

.outStockBillsEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
